import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange())),
    class: 
      `toggle-switch inline-block cursor-pointer ${
        _ctx.isActive ? 'toggle-active bg-red-lp-2400' : 'bg-gray-lp-200'
      }`
    
  }, [
    _hoisted_1
  ], 2))
}